module.exports = __webpack_public_path__ + "images/category_lp/fishing_gear/store_images/1_515894c9c046adb58ee0b167dcf66c77.png";